import { useAtomValue } from 'jotai'
import React from 'react'

import { AmplitudeProvider } from '~/components/providers/AmplitudeEventProvider'

import { isPercentageAtom } from '../../atoms'
import { type SurveyGroupQuestion } from '../../hooks/useMainQuery'
import { useQuestionsData } from '../../hooks/useQuestionsData'
import { useVisibleSurveys } from '../../hooks/useVisibleSurveys'
import { getDatum } from '../../utils'

import { HeadingContainer } from './HeadingContainer'
import { TimeSeriesContent } from './TimeSeriesContent'

export type QuestionContentProps = {
  question: SurveyGroupQuestion
}

export const QuestionContent = ({ question }: QuestionContentProps) => {
  const isPercentage = useAtomValue(isPercentageAtom)

  const surveys = useVisibleSurveys()
  const questionsData = useQuestionsData()
  const series = React.useMemo(
    () =>
      question.answerOptions.map((answerOption) => ({
        data: surveys.map((survey) =>
          getDatum(
            questionsData,
            (item) =>
              item.questionId === question.id &&
              item.option === answerOption.option &&
              item.surveyId === survey.id,
            isPercentage,
          ),
        ),
        name: answerOption.text,
        isLabelVisible: true,
      })),
    [isPercentage, question.answerOptions, question.id, questionsData, surveys],
  )

  return (
    <AmplitudeProvider eventNameSuffix="_customized KPI">
      <HeadingContainer indicator={question.id} label={question.name}>
        <TimeSeriesContent series={series} />
      </HeadingContainer>
    </AmplitudeProvider>
  )
}
